module.exports = __webpack_public_path__ + "static/keqing-b4d7950d021784665468d2a7e0fb664a.png";